import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'flyOverDuration'
})
export class FlyOverDurationPipe implements PipeTransform {

//   transform(value: string | null): string {
//     const [days, hour, mins] = value?.split(':')?.map(Number) || [];

// const totalHour = days * 24 + hour;

// return `${totalHour}h ${mins}m`;
//   }

// transform(value: any): string {
//   console.log('FlyOverDurationPipe INPUT:', value);  // <---- IMPORTANT

//   if (typeof value !== 'string') {
//     return '';
//   }

//   const parts = value.split(':').map(x => Number(x));

//   if (parts.length !== 3 || parts.some(isNaN)) {
//     return '';
//   }

//   const [days, hours, mins] = parts;
//   return `${days * 24 + hours}h ${mins}m`;
// }


transform(value: any): string {
  // console.log('FlyOverDurationPipe INPUT:', value);

  if (typeof value !== 'string') {
    return '';
  }

  const parts = value.split(':').map(Number);

  if (parts.some(isNaN)) {
    return '';
  }

  let totalHours = 0;
  let minutes = 0;

  // DD:HH:MM  (e.g. 00:12:50 → 12h 50m)
  if (parts.length === 3) {
    const [days, hours, mins] = parts;
    totalHours = days * 24 + hours;
    minutes = mins;
  }

  // HH:MM (e.g. 01:20 → 1h 20m)
  else if (parts.length === 2) {
    const [hours, mins] = parts;
    totalHours = hours;
    minutes = mins;
  }

  else {
    return '';
  }

  return `${totalHours}h ${minutes}m`;
}



}
